import { configureStore } from '@reduxjs/toolkit';
import {
  clinicianProfileBasicSlice,
  patientProfileSlice,
  patientListSlice,
  patientFeedbackListSlice,
  patientFeedbackSlice,
  timelineSlice,
  insightsSlices,
  actionsSlices,
  insightSettingsSlice,
  predictionSlice,
  popupSlice,
  dashboardSearchSlice,
  dataAnnotationSlice,
  preferencesSlice,
} from './ai2';
import { uiSlice } from './ui';
import dispatchErrorEvent from '../ai2/helpers/errorEvents';

export const store = configureStore({
  reducer: {
    clinicianProfile: clinicianProfileBasicSlice.reducer,
    preferences: preferencesSlice.reducer,
    patientFeedback: patientFeedbackSlice.reducer,
    patientFeedbackList: patientFeedbackListSlice.reducer,
    patientList: patientListSlice.reducer,
    patientProfile: patientProfileSlice.reducer,
    timeline: timelineSlice.reducer,
    prediction: predictionSlice.reducer,
    insights: insightsSlices.reducer,
    insightSettings: insightSettingsSlice.reducer,
    ui: uiSlice.reducer,
    actions: actionsSlices.reducer,
    popup: popupSlice.reducer,
    dashboardSearch: dashboardSearchSlice.reducer,
    dataAnnotation: dataAnnotationSlice.reducer,
  },
});

// Initialize previous state for selectedTenancy and dashSettings
let previousSelectedTenancy =
  store.getState().clinicianProfile.selectedTenancy?.tenancy_id;
let previousDashSettings = store.getState().clinicianProfile.dashSettings;
let stateChangeFlag = false;

// Subscribe to store updates
store.subscribe(() => {
  const state = store.getState();
  const currentSelectedTenancy =
    state.clinicianProfile.selectedTenancy?.tenancy_id;
  if (currentSelectedTenancy !== previousSelectedTenancy) {
    previousSelectedTenancy = currentSelectedTenancy;
    stateChangeFlag = true;
  }
  const currentDashSettings = state.clinicianProfile.dashSettings;
  if (currentDashSettings !== previousDashSettings) {
    previousDashSettings = currentDashSettings;
    stateChangeFlag = true;
  }
  if (stateChangeFlag) {
    localStorage.setItem(
      'clinicianProfileState',
      JSON.stringify({
        selectedTenancy: previousSelectedTenancy,
        dashSettings: previousDashSettings,
      }),
    );
    stateChangeFlag = false;
  }
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

function setErrorAction(param: any) {
  console.log('GLOBAL REACT ERROR CATCH', param);
  dispatchErrorEvent(param);
}

export function registerHandlers() {
  window.addEventListener('error', (event) => {
    setErrorAction({ message: event.message });
  });

  window.addEventListener('unhandledrejection', (event) => {
    const reason: any = (event as PromiseRejectionEvent).reason;
    if (reason && typeof reason === 'object') {
      setErrorAction(reason);
    } else {
      setErrorAction({ message: String(reason || 'Unhandled rejection') });
    }
  });
}
